import { useEffect } from 'react';
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { ON } from 'enums/signalrConnection';
import { SIGNALR_PATH } from 'constants/appUrls';
import { store } from 'store';

import { useQueryClient } from 'react-query';

const reactAppBaseUrl = import.meta.env.VITE_BASE_URL;
const url = `${reactAppBaseUrl}${SIGNALR_PATH}`;
const state = store.getState();
const connection = new HubConnectionBuilder()
    .configureLogging(LogLevel.Debug) // this has to go at some point
    .withUrl(url, { accessTokenFactory: () => state.auth.token })
    .withAutomaticReconnect()
    .build();

export const useSignalRConnection = ({ onDataReceived }) => {
    const client = useQueryClient();

    const handleOnInvalidateQuery = (data) => {
        client.invalidateQueries(data);
    };

    useEffect(() => {
        if (connection && connection.state === 'Disconnected') {
            connection.start();
        }
        // connection.start();

        connection.on(ON.invalidateQuery, handleOnInvalidateQuery);
        connection.on(ON.actionResponse, onDataReceived);

        return () => {
            connection.stop();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [client]);
};
